/**
 * CampaignSelect
 */
export { default as CampaignSelect } from './CampaignsPlatformSelect';

/**
 * CampaignFilter
 */
export { default as CampaignFilter } from './CampaignsPlatformFilter';

/**
 * CampaignLabel
 */
export { default as CampaignLabel } from './CampaignsPlatformLabel';

/**
 * EditCampaignAction
 */
export { default as EditCampaignAction } from './CampaignsPlatformEditAction';

/**
 * CampaignsProvider
 */
export { default as CampaignsProvider, useCampaignsContext as useCampaigns } from './CampaignsProvider';

/**
 * useObjectTypeHasCampaignsAccess
 */
export { useObjectTypeHasCampaignsAccess } from './hooks/useFetchCampaignsAssociationSettings';

/**
 * useFetchCampaignsAssociationSettings
 */
export { useFetchCampaignsAssociationSettings } from './hooks/useFetchCampaignsAssociationSettings';

/**
 * useCampaignsPlatformEditActionMenuItem
 */
export { useCampaignsPlatformEditActionMenuItem } from './hooks/useCampaignsPlatformEditActionMenuItem';

/**
 * CampaignsFrameworkAppSettingsResponseTypes
 */

/**
 * mapObjectType
 */
export { mapObjectType } from './hooks/useFetchObjectPropertyDefinitions';

/**
 * fetchAndDeleteCampaignsAssociation
 */
export { fetchAndDeleteCampaignsAssociation } from './api/CampaignsAssociation';

/**
 * MarketingEventCampaignAddPannel
 */
export { default as MarketingEventCampaignAddPannel } from './marketingEventCampaigns/MarketingEventCampaignAddPannel';

/**
 * CampaignsListPopover
 */
export { default as CampaignsPlatformListPopover } from './CampaignsPlatformListPopover';
/**
 * CampaignsPlatformTableCell
 */
export { default as CampaignsPlatformTableCell } from './CampaignsPlatformTableCell';
/**
 * useFetchAssociatedCampaigns
 */
export { useFetchAssociatedCampaigns } from './hooks/useFetchAssociatedCampaign';

/**
 * useFetchAssociationDefinition
 */
export { useFetchAssociationDefinition } from './hooks/useFetchAssociationDefinition';

/**
 * useResolveCampaignNames
 * Hook to resolve campaign GUIDs to their display names using the External Options API.
 * Uses reference-resolvers-lite which automatically batches and caches requests.
 */
export { useResolveCampaignNames } from './hooks/useResolveCampaignNames';
/**
 * getIsUngatedForOneToMany
 */
export { getIsUngatedForOneToMany } from 'campaigns-lib/utils/campaignGates';
export default 42;